const shouldBlockImageAction = target => {
  if (!(target instanceof Element)) {
    return false
  }

  return Boolean(target.closest(".protected-image-shell"))
}

export const onClientEntry = () => {
  const blockProtectedImageActions = event => {
    if (shouldBlockImageAction(event.target)) {
      event.preventDefault()
    }
  }

  document.addEventListener("contextmenu", blockProtectedImageActions)
  document.addEventListener("dragstart", blockProtectedImageActions)
}
